import { Background, Text, Image, Title, Container } from "./style";
import dev from "../../../assets/Images/dev.jpeg";
import apiEventos from "../../../services/apiEventos";
import React, { useState } from "react";

export default function Home() {
  const [hidden, setHidden] = useState(true);

  // Essa função foi criada apenas para testar conexão com o sistema de eventos
  // Ao clicar no botão, ele dispara essa função que no back do eventos fará
  // um console.log nos dados do usuário que fez a requisição
  // async function handleTestarEventos(e) {
  //   // Evita que o clique no botão dispare o onClick da div <Image> pai (Bubbling)
  //   e.stopPropagation();
  //   try {
  //     const response = await apiEventos.post("/reservas-automaticas/criar-reservas");      
  //     console.log(response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  return (
    <Background>
      <Container>
        <Title>Home Perfil Dev</Title>
        {/* Esse botão foi criado apenas para testar conexão com o sistema de eventos */}
        {/* <button onClick={handleTestarEventos}>Testar Conexão com eventos</button> */}
      </Container>

      <Image hidden={!!hidden} onClick={() => setHidden(!hidden)}>
        <Text>Bem-Vindo Dev!</Text>
        <img alt="Erro!" src={dev} />
      </Image>
    </Background>
  );
}
